export enum LanguageConst
{
    ENGLISH="English", BURMESE="Burmese"
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/resources/languageconst.ts